import { faHouse } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import VoxelAlert from '../../components/voxel/Alert/VoxelAlert';
import VoxelButton from '../../components/voxel/Buttons/VoxelButton';
import VoxelButtonGrid from '../../components/voxel/Buttons/VoxelButtonGrid';

export interface TeamMismatchPageProps {}

const TeamMismatchPage: React.FC<TeamMismatchPageProps> = ({}) => {
  return (
    <div className="fixed h-1/2 w-full flex flex-col items-center justify-center content-center p-12">
      <VoxelAlert title="Your team was changed in another tab" widthClass="w-[396]" severity="info">
        Go back to the start page to ensure that everything functions as intended
      </VoxelAlert>
      <div className="h-8" />
      <VoxelButtonGrid>
        <VoxelButton
          title="Back"
          startIcon={<FontAwesomeIcon icon={faHouse} />}
          onClick={() => (window.location.href = window.location.origin)}
        />
      </VoxelButtonGrid>
    </div>
  );
};

export default TeamMismatchPage;
